import React from 'react';
import getConfig from 'next/config';

import Container from 'components/Container';
import LazyLoadImage from 'components/LazyLoad/Image';

import styles from './styles.module.scss';

const {
	publicRuntimeConfig: { assetPrefix }
} = getConfig();

const AppPromo = () => {
	const backgroundSrc = `${assetPrefix}images/pushkinsCard/app.png`;
	const pushkinSrc = `${assetPrefix}images/pushkinsCard/pushkin.png`;
	const appStoreSrc = `${assetPrefix}images/pushkinsCard/links/app-store.svg`;
	const googlePlaySrc = `${assetPrefix}images/pushkinsCard/links/google-play.svg`;

	return (
		<Container>
			<div className={styles.block}>
				<div className={styles.content}>
					<div className={styles.title}>
						Как принять участие в&nbsp;программе?
					</div>
					<ol className={styles.list}>
						<li>Зарегистрироваться на&nbsp;портале&nbsp;«Госуслуги».</li>
						<li>Подтвердить учетную запись.</li>
						<li>Установить мобильное приложение&nbsp;«Госуслуги.Культура».</li>
						<li>
							Получить Пушкинскую карту&nbsp;— виртуальную или&nbsp;пластиковую
							карту платежной системы&nbsp;«Мир».
						</li>
						<li>Выбрать мероприятие из&nbsp;афиши в&nbsp;приложении.</li>
						<li>
							Купить билет в&nbsp;приложении, на&nbsp;сайте или в&nbsp;кассе
							музея.
						</li>
					</ol>
					<div className={styles.links}>
						<a
							href="https://apps.apple.com/ru/app/id1581979387"
							className={styles.link}
							target="_blank"
							rel="noopener"
						>
							<LazyLoadImage imageSrc={appStoreSrc}>
								<img
									className={styles.linkImage}
									src={appStoreSrc}
									alt="Доступно в App Store"
								/>
							</LazyLoadImage>
						</a>
						<a
							href="https://play.google.com/store/apps/details?id=ru.gosuslugi.culture"
							className={styles.link}
							target="_blank"
							rel="noopener"
						>
							<LazyLoadImage imageSrc={googlePlaySrc}>
								<img
									className={styles.linkImage}
									src={googlePlaySrc}
									alt="Доступно в Google Play"
								/>
							</LazyLoadImage>
						</a>
					</div>
				</div>
				<LazyLoadImage imageSrc={backgroundSrc}>
					<div
						className={styles.background}
						style={{
							backgroundImage: `url(${backgroundSrc}), url(${pushkinSrc})`
						}}
					/>
				</LazyLoadImage>
			</div>
		</Container>
	);
};

export default AppPromo;
